var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-895.189 -504.216)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(901 512)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2,4.579,9.749-4.595,21.378,4.579,19.646,8.066V18.432H-.268V7.816Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 9.739728927612305 -0.7811698913574219 L 1.835927963256836 5.389772415161133 L 2.377113342285156 6.401674747467041 C 2.609891891479492 6.836925029754639 2.731681823730469 7.322895050048828 2.731681823730469 7.816494941711426 L 2.731681823730469 15.43205451965332 L 16.64600372314453 15.43205451965332 L 16.64600372314453 8.065624237060547 C 16.64600372314453 7.602644920349121 16.7531623840332 7.145945072174072 16.95908355712891 6.731275081634521 L 17.60752296447754 5.425537109375 L 9.739728927612305 -0.7811698913574219 M 9.749302864074707 -4.594724655151367 L 21.37768363952637 4.578615188598633 L 19.64600372314453 8.065624237060547 L 19.64600372314453 18.43205451965332 L -0.2683181762695312 18.43205451965332 L -0.2683181762695312 7.816494941711426 L -1.999998092651367 4.578615188598633 L 9.749302864074707 -4.594724655151367 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(906.189 520.216)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 6,
    height: 7,
    fill: "none"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome);
export default __webpack_public_path__ + "static/media/icon-home.1bb029b4d99c8484cef0a7bdd0f219be.svg";
export { ForwardRef as ReactComponent };